import { get, isFunction } from 'lodash/fp';

export const compare =
    (accessor, direction = 1) =>
    (a, b) => {
        const f = isFunction(accessor) ? accessor : get(accessor);
        const x = f(a);
        const y = f(b);
        return (x < y ? -1 : x > y ? 1 : 0) * direction;
    };
